export const Card = () => {
  return (
    <>
      <li
        className="card-item"
        style={{
          backgroundImage:
            "url(" +
            "https://irp-cdn.multiscreensite.com/d8037e1a/dms3rep/multi/Functional+Medicine+Doctor+Chicago.jpeg" +
            ")",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div>
          <h3 className="heading">Panel Discussion on Drug resistant TB</h3>

          <div className="hello">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam
          </div>
        </div>
      </li>
    </>
  );
};
